import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { store } from '@/store'
import Router from '@/routes'
import AuthInitializer from '@/components/AuthInitializer'

/**
 * Main App component with Redux and routing setup
 */
export default function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <AuthInitializer />
        <Router />
      </BrowserRouter>
    </Provider>
  )
}

